<div class="wrapper">
  <p class="h-line color-light">
    <span class="skeleton-item">{{ 'accountUi.oAuthButtons.orContinueWith' | transloco }}</span>
  </p>
  <div class="d-flex ouath-container">
    <ng-container *ngFor="let provider of orderedProviders">
      <button
        *ngIf="getButton(provider) as oAuthButton"
        type="button"
        class="btn btn-social {{ oAuthButton.class }}"
        (click)="selectProvider(oAuthButton.provider)"
        [tooltipClass]="'tooltip ' + oAuthButton.tooltipClass"
        [yatTooltip]="oAuthButton.tooltip"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_ACCOUNT"
        matomoClickAction="Select_SignIn"
        [matomoClickName]="oAuthButton.provider">
        <yat-icon id="c83461f4-1490-47f1-94b1-27914123d6fe" [name]="oAuthButton.icon"></yat-icon>
      </button>
    </ng-container>
  </div>
</div>
